import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import {
  createProcessingSelector,
  removeErrorNotification,
  REMOVE_ADMIN,
  removeAdminRequest,
  useAppDispatch,
  useAppSelector,
  logoutRequest
} from 'store'
import { useDialog } from 'App/hooks'
import { Button, Checkbox, ConfirmationModal, ErrorModal } from 'App/components'

import styles from './UserProfileResignFromRoleConfirmContainer.module.scss'

type TUserProfileResignFromRoleConfirmContainerProps = {
  businessUserId: string
}

const processingSelector = createProcessingSelector([REMOVE_ADMIN])

export const UserProfileResignFromRoleConfirmContainer = ({
  businessUserId
}: TUserProfileResignFromRoleConfirmContainerProps) => {
  const dispatch = useAppDispatch()

  const processing = useAppSelector(processingSelector)
  const error = useAppSelector((state) => state.errors[REMOVE_ADMIN])

  const { open: checkboxState, toggle } = useDialog()

  const { t } = useTranslation()

  useEffect(
    () => () => {
      dispatch(removeErrorNotification(REMOVE_ADMIN))
    },
    [dispatch]
  )

  const handleSuccessResign = () => {
    dispatch(logoutRequest())
  }

  const handleRemoveAdmin = () => {
    dispatch(
      removeAdminRequest({
        onlyHidden: false,
        businessUserId,
        onlyDowngrade: !checkboxState,
        onSuccess: handleSuccessResign
      })
    )
  }

  return (
    <ConfirmationModal
      content={t('modal.resignFromAdminRoleConfirm.content')}
      endAdornment={
        <Checkbox
          classes={{ root: styles.checkbox }}
          checked={checkboxState}
          label={t('modal.resignFromAdminRoleConfirm.resignFromStaffCheckbox')}
          onChange={toggle}
        />
      }
      controls={
        <>
          <Button loading={processing} onClick={handleRemoveAdmin}>
            {t('modal.resignFromAdminRoleConfirm.submitButton')}
          </Button>
          <ErrorModal error={error} />
        </>
      }
    />
  )
}
